import { useTranslation } from "react-i18next";
import "./tarjeta.css";
import { useNavigate } from "react-router-dom";

const Tarjeta = ({ servicio , moneda}) => {
  const navigate = useNavigate();
  const {t} = useTranslation();
  //le agrege un div adicional llamado "contenidoTarjeta" para que el boton se muestre como en la version de tablet, dejo comentado el codigo original por si las moscas
  return (
    <article className="jbTarjeta" key={servicio.id}>
      <div className="contenidoTarjeta">
        <div className="jbTarjetaArriba">
          <div className="contenedorImagen">
            <img src={servicio.img} alt={t(servicio.titulo)} />
          </div>
          <h2 className="jbTituloServicio">{t(servicio.titulo)}</h2>
        </div>
        <div className="jbTarjetaAbajo">
          <p className="jbDescripcion">{t(servicio.descripcionTarjeta)}</p>
          <div className="jbInfoPrecio">
            <p className="jbPrecio">
              { moneda === "ARS" ?`${servicio.precio}` : servicio.precioConvertido ? `${moneda} ${servicio.precioConvertido}` : "cargando..."
              }
            </p>
            <p className="jbDuracion">{t(servicio.tiempo)}</p>
          </div>
        </div>
      </div>
      <button
        className="jbBtn" onClick={() => navigate(`/vistadetallada/${servicio.id}`)}>
        Más info
      </button>
    </article>
  );
};

export default Tarjeta;
